/**
 * Structured logger utility for consistent logging across the application.
 * Environment-aware: detailed logs in development, essential logs only in production.
 */

type LogLevel = 'info' | 'warn' | 'error';

interface LogMeta {
  [key: string]: unknown;
}

const formatMessage = (level: LogLevel, message: string, meta?: LogMeta): string => {
  const timestamp = new Date().toISOString();
  const metaStr = meta ? ` | ${JSON.stringify(meta)}` : '';
  return `[${timestamp}] [${level.toUpperCase()}] ${message}${metaStr}`;
};

export const logger = {
  info: (message: string, meta?: LogMeta) => {
    if (import.meta.env.DEV) {
      console.info(formatMessage('info', message, meta));
    }
  },

  warn: (message: string, meta?: LogMeta) => {
    if (import.meta.env.DEV) {
      console.warn(formatMessage('warn', message, meta));
    }
  },

  error: (message: string, error?: unknown, meta?: LogMeta) => {
    const errorDetails = error instanceof Error ? { name: error.name, message: error.message, stack: error.stack } : error;
    console.error(formatMessage('error', message, { ...meta, error: errorDetails }));
  },
};
